import AppFunction from "../../../../../../core/helpers/app/AppFunction.js";

export const table = {
    data() {
        return {
            tableColumns: [
                { 
                    title: this.$t('Code'), 
                    modifier : (_) => {
                        return `class=text-center`
                    },
                    key: 'Code',
                    type: 'custom-html',
                    isVisible: true,
                    ClassName: 'center',
                    modifier: (value) => {
                        return `<div">
                                <span style="font-weight: bolder;">${value}</span> 
                            </div>`;
                    }
                },
                { 
                    title: this.$t('Title'), 
                    modifier : (_) => {
                        return `class=text-center`
                    },
                    key: 'Title',
                    type: 'custom-html',
                    isVisible: true,
                    ClassName: 'center',
                    modifier: (value) => {
                        return `<div">
                                <span style="font-weight: bolder;">${value}</span> 
                            </div>`;
                    }
                },
                { 
                    title: this.$t('Symbol'), 
                    modifier : (_) => {
                        return `class=text-center`
                    },
                    key: 'simbolo',
                    type: 'custom-html',
                    isVisible: true,
                    ClassName: 'center',
                    modifier: (value) => {
                        return `<div">
                                <span style="font-weight: bolder;">${value}</span> 
                            </div>`;
                    }
                },
            
                { title: this.$t('action'), type: 'action', key: 'action' },
            ]
        };
    }
}